import { render, staticRenderFns } from "./ColumnSetting.vue?vue&type=template&id=f932a274&scoped=true"
import script from "./ColumnSetting.vue?vue&type=script&lang=js"
export * from "./ColumnSetting.vue?vue&type=script&lang=js"
import style0 from "./ColumnSetting.vue?vue&type=style&index=0&id=f932a274&prod&lang=scss"
import style1 from "./ColumnSetting.vue?vue&type=style&index=1&id=f932a274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f932a274",
  null
  
)

export default component.exports